import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NavigationComponent } from '@shared/components/navigation/navigation.component';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AlertServiceWrapperComponent } from '@shared/components/alert-service-wrapper/alert-service-wrapper.component';
import { CollapseService } from '@app/core/services/collapse.service';
import { NgClass } from '@angular/common';
import { HotkeyService } from '@app/core/services/hotkey.service';
import { HotkeyIndexComponent } from '@shared/components/hotkey-index/hotkey-index.component';
import { VersionUpdateBannerComponent } from '@shared/components/version-update-banner/version-update-banner.component';

/** Languages **/
import translationsDA from "@public/i18n/da.json";
import { UserService } from '@app/core/services/user.service';
import { ThemeService } from '@app/core/services/theme.service';
import { AlertService } from '@app/core/services/alert.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavigationComponent, AlertServiceWrapperComponent, NgClass, HotkeyIndexComponent, VersionUpdateBannerComponent],
  providers: [ HttpClient ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  // Eagerly instantiate ThemeService so the dark-mode effect runs on every bootstrap,
  // not only when the settings page is first visited.
  private readonly themeService = inject(ThemeService);

  public isIframe: boolean = false;

  @ViewChild(HotkeyIndexComponent) private readonly hotkeyIndex!: HotkeyIndexComponent;

  constructor(
    private readonly translate: TranslateService,
    private readonly userService: UserService,
    private readonly alertService: AlertService,
    public readonly collapseService: CollapseService,
    private readonly router: Router,
    private readonly hotkeyService: HotkeyService,
  ) {
    /** DA Translation **/
    this.translate.setTranslation('da', translationsDA);
    this.translate.setDefaultLang('da');

    /** Check if solution is running in iframe **/
    this.isIframe = window !== globalThis.parent && !globalThis.opener;

    /** Global hotkeys **/
    this.hotkeyService.register({
      id: 'global-create-meteringpoint',
      keys: 'mod+shift+m',
      label: 'hotkeys.label.createMeteringPoint',
      group: 'hotkeys.group.navigation',
      callback: () => this.router.navigate(['/meteringpoint/create']),
    });

    this.hotkeyService.register({
      id: 'global-create-connectionpoint',
      keys: 'mod+shift+s',
      label: 'hotkeys.label.createConnectionPoint',
      group: 'hotkeys.group.navigation',
      callback: () => this.router.navigate(['/connectionpoint/create']),
    });

    this.hotkeyService.register({
      id: 'global-hotkey-index',
      keys: 'f1',
      label: 'hotkeys.label.openIndex',
      group: 'hotkeys.group.navigation',
      callback: () => this.hotkeyIndex?.toggle(),
    });
  }

  public async ngOnInit(): Promise<void> {
    const user = await this.userService.fetchUser();
    this.alertService.setGlobalReaderMode(
      user?.forceGlobalReader
        ? user.forceGlobalReaderMessage || 'common.globalReaderMode.message'
        : null,
    );
  }
}
